import { Link } from "react-router-dom";
import { Page } from "../../../../components/page/page";
import { useLocalization } from "../../../../hooks/use-localization/useLocalization";
import { useUser } from "../../../../hooks/use-user/useUser";
import { Form } from "../../../../components/form/form";

export const Phone: React.FC = () => {
  const { user, setUser } = useUser();
  const { localize } = useLocalization();

  if (!user) {
    return null;
  }

  return (
    <Page title={localize("phone")}>
      <Form
        action="/me"
        method="PATCH"
        actionLabel={localize("save")}
        onSuccess={setUser}
        successMessage={localize("saved")}
      >
        <label>
          {localize("phone")}
          <input
            type="text"
            name="phone"
            defaultValue={user.phone}
            autoComplete="tel-local"
          />
        </label>
      </Form>
      <Link className="button secondary" to="../" relative="path">
        {localize("back")}
      </Link>
    </Page>
  );
};
